import { createBrowserRouter } from "react-router";
import { RouterProvider } from "react-router/dom";

import { ROUTER_ROUTES } from "./router.constant";

export const Router = () => {
  return <RouterProvider router={createBrowserRouter(ROUTER_ROUTES)} />;
};
